import { render, staticRenderFns } from "./index.vue?vue&type=template&id=8eacaf48"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8eacaf48')) {
      api.createRecord('8eacaf48', component.options)
    } else {
      api.reload('8eacaf48', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=8eacaf48", function () {
      api.rerender('8eacaf48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/index.vue"
export default component.exports